import { render, staticRenderFns } from "./InventTableMain.vue?vue&type=template&id=3d577a38"
import script from "./InventTableMain.vue?vue&type=script&lang=js"
export * from "./InventTableMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports